import { Utils } from '@microfrontends/react-components'
import { ACCESS_TOKEN_LENGTH } from "@/common/constants"
import { TUser } from "@/common/types/user"
import { TAppState, TAction } from "./types"
import { ACTION } from "./action"

export const jobDetailReducer = (state: TAppState, action: TAction): TAppState => {
    const { type, payload } = action

    switch (type) {
        case ACTION.SET_USER: {
            const user = payload as TUser
            user.accessToken = user.accessToken.length === ACCESS_TOKEN_LENGTH ? user.accessToken : Utils.decrypt(user.accessToken)

            return { ...state, user: user }
        }
        default:
            console.error('Unknown type of Reducer')
            return { ...state }
    }
}
